import { Component, Input, OnInit } from '@angular/core';
import { TimelineSection } from '../../../../_models/timeline-models/section-listing.model';

@Component({
    selector: 'quiz-section',
    templateUrl: './quiz-section.component.html',
    styleUrls: ['./quiz-section.component.css'],
    standalone: false
})
export class QuizSectionComponent implements OnInit {

  @Input("timelineSection") timelineSection: TimelineSection;

  constructor(
  ) { }

  ngOnInit() {
  }

}
